import state from './userorg.state'
import mutations from './userorg.mutations'
import actions from './userorg.actions'

export default {
  state,
  mutations,
  actions
}
